/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="82.96" height="94.39" viewBox="0 0 82.96 94.39" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <defs>
          <mask id="aaa9ad8b-a3ef-4096-af6e-7e3cd2102e32" x="0" y="0" width="82.96" height="94.39" maskUnits="userSpaceOnUse">
            <g transform="translate(-36 -30)">
              <polygon points="36 124.39 118.96 124.39 118.96 30 36 30 36 124.39" fill="#fff" fillRule="evenodd"/>
            </g>
          </mask>
        </defs>
        <g>
          <path d="M77.48,41.42A41.49,41.49,0,1,0,119,82.9,41.53,41.53,0,0,0,77.48,41.42Zm0,2.5a39,39,0,1,1-39,39A39,39,0,0,1,77.48,43.92Z" transform="translate(-36 -30)" fill="#0e497b"/>
          <g mask="url(#aaa9ad8b-a3ef-4096-af6e-7e3cd2102e32)">
            <polygon points="35.34 12.67 48.57 12.67 48.57 4.3 35.34 4.3 35.34 12.67" fill="#0e497b" fillRule="evenodd"/>
          </g>
          <g mask="url(#aaa9ad8b-a3ef-4096-af6e-7e3cd2102e32)">
            <path d="M88.41,36.81H67.51a.5.5,0,0,1-.5-.5V30.5a.51.51,0,0,1,.5-.5h20.9a.51.51,0,0,1,.5.5v5.81a.5.5,0,0,1-.5.5" transform="translate(-36 -30)" fill="#0e497b" fillRule="evenodd"/>
          </g>
          <g mask="url(#aaa9ad8b-a3ef-4096-af6e-7e3cd2102e32)">
            <path d="M75.84,60.56v3.88l-.6.11-.61.12a9.3,9.3,0,0,0-7,5.68,11.72,11.72,0,0,0-.81,5.3,9.13,9.13,0,0,0,4.87,7.74,41.32,41.32,0,0,0,4.07,1.82c1.7.72,3.43,1.37,5.13,2.09a3.11,3.11,0,0,1,1.94,3.39,3.39,3.39,0,0,1-2.72,3.39,9.71,9.71,0,0,1-2.15.24,5.35,5.35,0,0,1-5.47-4c-.15-.48-.27-1-.42-1.49l-6.49,1.67a13.54,13.54,0,0,0,3.14,6.43,11,11,0,0,0,7.12,3.29v5H80v-5c.85-.17,1.67-.3,2.47-.5a9.68,9.68,0,0,0,6.83-5.55,11.29,11.29,0,0,0,.79-6.78A8.93,8.93,0,0,0,85.59,81a51.16,51.16,0,0,0-6.22-2.72c-1.27-.51-2.51-1.09-3.75-1.7a2.71,2.71,0,0,1-1.39-1.69,3.8,3.8,0,0,1,2.65-4.78,4.42,4.42,0,0,1,4.35,1.14A8.11,8.11,0,0,1,83,73.92c.15.32.28.64.43,1l5.81-2.4a11.67,11.67,0,0,0-2.13-4.38A10.28,10.28,0,0,0,80,64.44V60.56Z" transform="translate(-36 -30)" fill="#ffb81c" fillRule="evenodd"/>
          </g>
          <g mask="url(#aaa9ad8b-a3ef-4096-af6e-7e3cd2102e32)">
            <path d="M110.72,52.32,100.27,44a.5.5,0,0,1-.08-.7l2.75-3.47a.51.51,0,0,1,.71-.08l10.44,8.28a.5.5,0,0,1,.08.7l-2.75,3.47a.49.49,0,0,1-.7.08" transform="translate(-36 -30)" fill="#0e497b" fillRule="evenodd"/>
          </g>
          <g mask="url(#aaa9ad8b-a3ef-4096-af6e-7e3cd2102e32)">
            <polygon points="68.59 23.74 64.31 20.34 69.05 14.37 73.33 17.76 68.59 23.74" fill="#0e497b" fillRule="evenodd"/>
          </g>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'StopwatchWithDollarSignIcon';

export default Icon;
